import PropTypes from 'prop-types';
import './button.scss';

const Button = ({ label, onClick, type = 'button', outline }) => {
  const handleClick = () => {
    if (onClick) {
      return onClick();
    }

    return null;
  };
  return (
    <button
      type={type}
      className={`button btn ${outline ? 'button--outline' : ''}`}
      onClick={handleClick}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  outline: PropTypes.any
};

export default Button;
